import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Summary from '../Summary';
import SummaryTrials from '../SummaryTrials';
import SummaryStudents from '../SummaryStudents';
import { analyticsDataProps } from '../../shared/prop-types';

export const I18nPrefix = 'strava.subscriptions.checkout.summary.trial';

// eslint-disable-next-line react/prefer-stateless-function
class SummaryContainer extends React.Component {
  render() {
    const {
      isTrial,
      isStudentPromotion,
      cartData,
      trialInfo,
      analyticsData
    } = this.props;

    let content;
    // render student summary if isStudentPromotion === true regardless of trial status
    if (isTrial && !isStudentPromotion) {
      content = <SummaryTrials />;
    } else if (isStudentPromotion) {
      content = (
        <SummaryStudents
          cartData={cartData}
          trialInfo={trialInfo}
          isTrial={isTrial}
          analyticsData={analyticsData}
        />
      );
    } else {
      content = <Summary />;
    }

    return content;
  }
}

SummaryContainer.propTypes = {
  isTrial: PropTypes.bool.isRequired,
  isStudentPromotion: PropTypes.bool,
  cartData: PropTypes.shape({
    selectedPackages: PropTypes.arrayOf(PropTypes.object).isRequired,
    currency: PropTypes.string.isRequired,
    recurringAmount: PropTypes.number.isRequired,
    billedToday: PropTypes.number.isRequired
  }).isRequired,
  trialInfo: PropTypes.shape({
    trialLength: PropTypes.number
  }),
  analyticsData: analyticsDataProps.isRequired
};

SummaryContainer.defaultProps = {
  isStudentPromotion: false,
  trialInfo: null
};

const mapStateToProps = (state) => {
  return {
    isTrial: state.isTrial,
    isStudentPromotion: state.isStudentPromotion,
    cartData: state.products[state.duration],
    trialInfo: state.trialInfo,
    analyticsData: state.analytics_data
  };
};

export default connect(mapStateToProps)(SummaryContainer);
